import { STORAGE_KEYS as s } from "./storage-manager.js";
import m from "./subscription-manager.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
export default class kt {
  constructor(t, i, s) {
    (this.B = t),
      (this.gh = i),
      (this.ph = s),
      (this.B = t),
      (this.gh = i || !1),
      (this.ph = s),
      (this.Fh = new m()),
      (this.kh = 0),
      (this.fh = 1);
  }
  wh() {
    return this.gh;
  }
  jh() {
    return this.B.dt(s.ft.xh);
  }
  setSdkAuthenticationSignature(t) {
    const i = this.jh();
    this.B.bt(s.ft.xh, t);
    const e = et.Us.Rs;
    new et(e, E).setItem(e.Fs.qh, this.fh, t), i !== t && this.Z();
  }
  yh() {
    this.B.zt(s.ft.xh);
    const t = et.Us.Rs;
    new et(t, E).je(t.Fs.qh, this.fh);
  }
  subscribeToSdkAuthenticationFailures(t) {
    return this.ph.Rt(t);
  }
  Bh(t) {
    this.ph.L(t);
  }
  Gh() {
    this.Fh.removeAllSubscriptions();
  }
  Hh() {
    this.kh += 1;
  }
  Jh() {
    return this.kh;
  }
  Z() {
    this.kh = 0;
  }
}
